import "./styles.sass";

import React, { FC, useContext, useState, useEffect } from "react";
import DocsItem from "./DocsItem";
import { formatDocName, isEmpty } from "../../../utils";
import AdminDoc from "./AdminDoc";
import Button from "../../../components/UI/button/GgButton";
import { useModal } from "../../../customHooks/useModal";
import Modal from "../../../components/modal/Modal";
import Input from "../../../components/UI/input/GgInput";
import Emptiness from "../../../components/UI/emptiness/Emptiness";
import Gosa from "../../../assets/images/Gosa_avatar.png";
import { Context } from "../../..";
import Spinner from "../../../components/UI/spinner/Spinner";
import Timofey from "../../../assets/images/Timofey_avatar.png";
import File from "../../../assets/icons/file.svg";
import { relative } from "path";
import "../../../App.css";
import { showErrorToast, showSuccessToast } from "../../../components/toasts";

interface IUserDocs {
  value: string;
  data?: any;
}

const IMAGE_FORMATS = [
  "svg", "png", "jpg", "jpeg", "gif"
]

const UserDocs: FC<IUserDocs> = ({ data: userData }) => {
  const data = userData.selectedUser.docs;

  const [bannerImage, setBannerImage] = useState<string>("");
  const [docName, setDocName] = useState<string>("");
  const [documents, setDocument] = useState<File | null>(null);
  const [docFileName, setDocFileName] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const [objectURL, setObjectURL] = useState<string>("");
  const [adminPermissionData, setAdminPermissionData] = useState<any>()

  const { users, roles, store } = useContext(Context)

  const adminDocument = (e: any) => {
    if (e.target.files && e.target.files.length > 0) {
      console.log(e.target.files)
      setDocument(e.target.files[0])
      if (e.target.files[0]) {
        setDocFileName(e.target.files[0].name)
      }
    }
  }

  const uploadAdminDocData = async () => {
    modal.closeModal()
    if (docName && documents) {
      setLoading(true);
      let formData = new FormData()
      const userId = users.selectedUser._id;

      formData.append('id', userId)
      formData.append('fileName', docName)
      formData.append('file', documents)

      await users.uploadAdminDocument(formData)
      loadNewUser()
      setDocFileName("")
      setDocument(null)
      setDocName("")
      setLoading(false);
      showSuccessToast("Document uploaded successfully");
    } else {
      showErrorToast("Invalid field !")
    }
  }

  async function loadNewUser() {
    const response = await users.loadOne(users.selectedUser._id);
    if (response) {
      users.setSelectedUser(response);
    }
  }

  const isDataEmpty = (data: any) => {
    if (data === undefined) return true;
    if (Object.values(data).length === 0) return true;
    if (
      Object.values(data).every(
        (item: any) =>
          item === "" ||
          (item !== null &&
            Object.values(item).every((obj) => obj === "" || obj === null))
      )
    )
      return true;
    return false;
  };

  const getElement = () => {
    let data = document.getElementById("file")
    console.log("data", data)
    data?.click()
  }
  const modal = useModal();

  const loadNewData = async () => {
    const userData = store?.user?.role?.find((par: any) => par?.path === "control")?.children?.find((child: any) => child.path === "users")
    setAdminPermissionData(userData)
  };

  useEffect(() => {
    loadNewData()
  }, [])
  
  return (
    <section className="section">
      <div className="section-title">User documents</div>
      <div className="documents">
        <div className="doc-type">
          <div className="doc-name" style={{ "display": "flex", "justifyContent": "space-Between", "alignItems": "center" }}>
            <div>Uploaded By Admin</div>
            <div>
              {adminPermissionData?.add ? (
                <Button
                label="Add Document"
                onPress={modal.openModal}
              />
              ): ""}
            </div>
            <Modal
              show={modal.showModal}
              onClose={() => {
                modal.setModalShow(false)
                setDocFileName("")
                setDocument(null)
                setDocName("")
              }}
              title=""
              showSubmit={true}
              submitLabel="Submit"
              onSubmit={uploadAdminDocData}
            >
              <Input
                label="Document Name"
                type="text"
                required
                placeholder="Document Name"
                onChange={(value) => setDocName(value)}
              />
              {docFileName ?
                <div>
                  <div style={{
                    "border": "1px solid #E5E1EC",
                    "borderRadius": "1rem",
                    "paddingInline": "1rem",
                    "outline": "none",
                    "transition": "all 0.2s ease-in-out",
                    position: "relative"
                  }}
                    onClick={() => getElement()}
                  // type="file"
                  >
                    <div style={{ "textAlign": "center", "height": "66vh", "display":"contents" }}>
                      <div style={{ "display": "flex", "justifyContent": "center", "alignItems": "center", "height": "100%" }}>
                        {documents && IMAGE_FORMATS.includes(docFileName.split(".")[1]) ? <img src={URL.createObjectURL(documents)} alt="Screenshot" style={{width:"85%", padding:"2rem"}}/>
                          : <div style={{display:"flex",flexDirection:"column", height:"100%", justifyContent:"center"}}>
                              <img src={File} alt="" style={{width:"100%", height:"30%"}}/>
                              <div style={{fontSize:"1.5rem"}}>{docFileName}</div>
                            </div>
                        }
                      </div>
                    </div>

                  </div>
                  <label className="upload" style={{ "marginBottom": "2rem" }}>
                    <input type="file" onChange={(e) => adminDocument(e)} id="file" />
                    <span className="file-button-label">Upload File</span>
                  </label>
                </div> :
                <div>
                  <div className="profile-image-upload-div" style={{
                    "border": "1px solid #E5E1EC",
                    "borderRadius": "1rem",
                    "paddingInline": "1rem",
                    "outline": "none",
                    "transition": "all 0.2s ease-in-out",
                    position: "relative"
                  }}
                    onClick={() => getElement()}
                  >
                    <div className="profile-img-input">
                      <Emptiness icon={Gosa} />
                    </div>
                  </div>
                  <div style={{ textAlign: "center" }}>
                    <label className="upload upload-button-img">
                      <input type="file" onChange={(e) => adminDocument(e)} id="file" />
                      <span className="file-button-label">Upload File</span>
                    </label>
                  </div>
                </div>
              }
            </Modal>
          </div>
          {loading ? (
            <Spinner />
          ) : (
            <div className="doc-cards-list">
              <div className="cards-wrapper">
                {!isEmpty(data?.adminDocs) ?
                  Object.entries(data.adminDocs).map(
                    ([key, value]: any, index) => {
                      if (isDataEmpty(value)) return null;

                      if (key === "other" && value.length > 0)
                        return (
                          <>
                            {/* <div className="sub-section-name">Others:</div> */}
                            <div className="cards-wrapper">
                              {value.map((item: any, i: number) => (
                                <AdminDoc
                                  user={userData}
                                  key={key}
                                  values={item}
                                  pathItem={`adminDocs/${key}/${i}`}
                                  actionData={adminPermissionData}
                                />
                              ))}
                            </div>
                          </>
                        )
                      if (!value?.name) return null;
                      return (
                        <AdminDoc
                          user={userData}
                          key={key}
                          values={value}
                          pathItem={`adminDocs/${key}`}
                          actionData={adminPermissionData}
                        />
                      );
                    }
                  )
                  : <Emptiness icon={Timofey} content="There are no Document" />
                }
              </div>
            </div>
          )}
        </div>
        {!isEmpty(data?.verification_ID) && <div className="doc-type">
          <div className="doc-name">Verification ID</div>
          <div className="doc-cards-list">
            <div className="cards-wrapper">
              {!isEmpty(data?.verification_ID) &&
                Object.entries(data.verification_ID).map(
                  ([key, value]: any, index) => {
                    if (isDataEmpty(value)) return null;
                    if (key === "other" && value.length > 0)
                      return (
                        <>
                          <div className="sub-section-name">Others:</div>
                          <div className="cards-wrapper">
                            {value.map((item: any, i: number) => (
                              <DocsItem
                                user={userData}
                                key={key}
                                values={item}
                                pathItem={`verification_ID/${key}/${i}`}
                                actionData={adminPermissionData}
                              />
                            ))}
                          </div>
                        </>
                      );
                    if (!value?.name) return null;
                    return (
                      <DocsItem
                        user={userData}
                        key={key}
                        values={value}
                        pathItem={`verification_ID/${key}`}
                        actionData={adminPermissionData}
                      />
                    );
                  }
                )}
            </div>
          </div>
        </div>}
        {!isEmpty(data?.income_verification) && <div className="doc-type">
          <div className="doc-name">Income Verification</div>
          <div className="doc-cards-list">
            {!isEmpty(data?.income_verification) &&
              Object.entries(data.income_verification).map(
                ([key, value]: any) => {
                  if (isDataEmpty(value)) return null;
                  return (
                    <div className="sub-section">
                      <div className="sub-section-name">
                        {formatDocName(key)}:
                      </div>
                      <div className="cards-wrapper">
                        {Object.entries(value).map(
                          ([subkey, subvalue]: any, index1) => {
                            if (subkey === "other" && subvalue.length > 0)
                              return (
                                <>
                                  <div className="sub-section-name">
                                    Others:
                                  </div>
                                  <div className="cards-wrapper">
                                    {subvalue.map(
                                      (item: any, index2: number) => (
                                        <DocsItem
                                          user={userData}
                                          key={index2}
                                          values={item}
                                          pathItem={`income_verification/${key}/${subkey}/${index2}`}
                                          actionData={adminPermissionData}
                                        />
                                      )
                                    )}
                                  </div>
                                </>
                              );
                            if (!subvalue?.name) return null;
                            return (
                              <DocsItem
                                user={userData}
                                key={subkey}
                                values={subvalue}
                                pathItem={`income_verification/${key}/${subkey}`}
                                actionData={adminPermissionData}
                              />
                            );
                          }
                        )}
                      </div>
                    </div>
                  );
                }
              )}
          </div>
        </div>}
        {!isEmpty(data?.additional_income) && <div className="doc-type">
          <div className="doc-name">Additional Income</div>
          <div className="doc-cards-list">
            {!isEmpty(data?.additional_income) &&
              Object.entries(data.additional_income).map(
                ([key, value]: any, index4) => {
                  if (isDataEmpty(value)) return null;
                  return (
                    <div className="sub-section">
                      <div className="sub-section-name">
                        {formatDocName(key)}:
                      </div>
                      <div className="cards-wrapper">
                        {Object.entries(value).map(
                          ([subkey, subvalue]: any) => {
                            if (subkey === "other" && subvalue.length > 0)
                              return (
                                <>
                                  <div className="sub-section-name">
                                    Others:
                                  </div>
                                  <div className="cards-wrapper">
                                    {subvalue.map(
                                      (item: any, index3: number) => (
                                        <DocsItem
                                          user={userData}
                                          key={index3}
                                          values={item}
                                          pathItem={`additional_income/${key}/${subkey}/${index3}`}
                                          actionData={adminPermissionData}
                                        />
                                      )
                                    )}
                                  </div>
                                </>
                              );
                            if (!subvalue?.name) return null;
                            return (
                              <DocsItem
                                user={userData}
                                key={subkey}
                                values={subvalue}
                                pathItem={`additional_income/${key}/${subkey}`}
                                actionData={adminPermissionData}
                              />
                            );
                          }
                        )}
                      </div>
                    </div>
                  );
                }
              )}
          </div>
        </div>}
        {!isEmpty(data?.statements) && <div className="doc-type">
          <div className="doc-name">Statements</div>
          <div className="doc-cards-list">
            {!isEmpty(data?.statements) &&
              Object.entries(data.statements).map(
                ([key, value]: any, index5) => {
                  if (isDataEmpty(value)) return null;
                  return (
                    <div className="sub-section">
                      <div className="sub-section-name">
                        {formatDocName(key)}:
                      </div>
                      <div className="cards-wrapper">
                        {Object.entries(value).map(
                          ([subkey, subvalue]: any) => {
                            if (subkey === "other" && subvalue.length > 0)
                              return (
                                <>
                                  <div className="sub-section-name">
                                    Others:
                                  </div>
                                  <div className="cards-wrapper">
                                    {subvalue.map((item: any, index6: number) => (
                                      <DocsItem
                                        user={userData}
                                        key={index6}
                                        values={item}
                                        pathItem={`statements/${key}/${subkey}/${index6}`}
                                        actionData={adminPermissionData}
                                      />
                                    ))}
                                  </div>
                                </>
                              );
                            if (!subvalue?.name) return null;
                            return (
                              <DocsItem
                                user={userData}
                                key={subkey}
                                values={subvalue}
                                pathItem={`statements/${key}/${subkey}`}
                                actionData={adminPermissionData}
                              />
                            );
                          }
                        )}
                      </div>
                    </div>
                  );
                }
              )}
          </div>
        </div>}
        {!isEmpty(data?.my_other_documents) && <div className="doc-type">
          <div className="doc-name">Other Documents</div>
          <div className="doc-cards-list">
            {!isEmpty(data?.my_other_documents) &&
              Object.entries(data.my_other_documents).map(
                ([key, value]: any, index7) => {
                  return (
                    <div className="sub-section">
                      <div className="cards-wrapper">
                        {Object.entries(value).map(
                          ([subkey, subvalue]: any) => {
                            if (subkey === "other" && subvalue.length > 0)
                              return (
                                <div className="cards-wrapper">
                                  {subvalue.map((item: any, index8: number) => (
                                    <DocsItem
                                      user={userData}
                                      key={index8}
                                      values={item}
                                      pathItem={`my_other_documents/${key}/${subkey}/${index8}`}
                                      actionData={adminPermissionData}
                                    />
                                  ))}
                                </div>
                              );
                            if (!subvalue?.name) return null;
                            return (
                              <DocsItem
                                user={userData}
                                key={subkey}
                                values={subvalue}
                                pathItem={`my_other_documents/${key}/${subkey}`}
                                actionData={adminPermissionData}
                              />
                            );
                          }
                        )}
                      </div>
                    </div>
                  );
                }
              )}
          </div>
        </div>}
        {/* {renderData(data)} */}
      </div>
    </section >
  );
};

export default UserDocs;
